import script from "./mechanismManage.vue?vue&type=script&setup=true&lang=js"
export * from "./mechanismManage.vue?vue&type=script&setup=true&lang=js"

import "./mechanismManage.vue?vue&type=style&index=0&id=660d4a0e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-660d4a0e"]])

export default __exports__